import React, { useEffect, useState } from 'react';
import { getConsent, setConsent, loadTrackers } from './consent';

export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choice = getConsent();
    if (choice === 'granted') {
      loadTrackers();
    } else if (choice == null) {
      setVisible(true);
    }
    // 'denied' → load nothing, show nothing
  }, []);

  if (!visible) return null;

  const accept = () => {
    setConsent('granted');
    loadTrackers();
    setVisible(false);
  };

  const reject = () => {
    setConsent('denied');
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 2147483647,
        background: 'rgba(17,17,17,0.97)',
        color: '#fff',
        padding: '16px 20px',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        fontSize: '14px',
        lineHeight: 1.4,
      }}
    >
      <span style={{ maxWidth: 720 }}>
        We use cookies and similar technologies for analytics and marketing. These do not load
        until you accept. See our{' '}
        <a href="/privacy-policy" style={{ color: '#2dd4bf', textDecoration: 'underline' }}>
          Privacy Policy
        </a>
        .
      </span>
      <span style={{ display: 'flex', gap: '8px' }}>
        <button
          type="button"
          data-testid="consent-reject"
          onClick={reject}
          style={{
            background: 'transparent',
            color: '#fff',
            border: '1px solid #888',
            borderRadius: 4,
            padding: '8px 16px',
            cursor: 'pointer',
          }}
        >
          Reject
        </button>
        <button
          type="button"
          data-testid="consent-accept"
          onClick={accept}
          style={{
            background: '#0d9488',
            color: '#fff',
            border: 'none',
            borderRadius: 4,
            padding: '8px 16px',
            cursor: 'pointer',
            fontWeight: 600,
          }}
        >
          Accept All
        </button>
      </span>
    </div>
  );
}
